import apiClient from "./client";



export interface DisplaySettings {
    theme: string;
    interface_language: string;
}

export interface IntegrationSettings {
    google_translate: boolean;
    tts_voice: boolean;
    tts_voice_language: string;
    tts_voice_model: string;
    tts_voice_sample_rate: number;
    /** Voice used to speak native-language text (e.g. translations). */
    tts_voice_language_native?: string;
    tts_voice_model_native?: string;
    tts_voice_sample_rate_native?: number;
    tts_list_models?: string[];
    default_dictionary: string;
    stt_record: boolean;
}

export interface LearningSettings {
    difficulty_level: string;
    review_interval: string;
    spaced_repetition: boolean;
    audio_pronunciation: boolean;
    enable_spelling: boolean;
    enable_type_in: boolean;
    enable_fill_blank: boolean;
    // Highest useProficiencyTier promotion offer (1 or 2) the user has already
    // responded to (confirmed or dismissed) — persisted server-side so it
    // survives across devices/browsers instead of living only in localStorage.
    // Absent/0 means "never offered".
    last_offered_proficiency_tier?: number;
}

export interface NotificationSettings {
    email_notifications: boolean;
    push_notifications: boolean;
    in_app_notifications: boolean;
    daily_reminders: boolean;
    reminders_reviews_due: boolean;
    quiet_hours_enabled: boolean;
    reminder_time: string;
    reminder_frequency: string;
    quiet_start_time: string;
    quiet_end_time: string;
    timezone: string;
}

export interface PrivacySettings {
    usage_data_collection: boolean;
    share_progress: boolean;
    third_party_services: boolean;
    profile_visibility: string;
    collections_visibility: string;
    stats_visibility: string;
}

export interface UserSettings {
    user_id: number;
    native_language: string;
    learning_language: string;
    daily_goal: string;
    target_level: string;
    default_language: string;
    languages: string;
    display_settings?: DisplaySettings;
    integration_settings?: IntegrationSettings;
    learning_settings?: LearningSettings;
    notification_settings?: NotificationSettings;
    privacy_settings?: PrivacySettings;
    friend_id?: number;
    onboarding_step?: number;
    onboarding_complete?: boolean;
}

export interface UpdateSettingsRequest {
    first_name?: string;
    last_name?: string;
    email?: string;
    native_language?: string;
    learning_language?: string;
    daily_goal?: string;
    target_level?: string;
    default_language?: string;
    languages?: string;
    display_settings?: DisplaySettings;
    integration_settings?: IntegrationSettings;
    learning_settings?: LearningSettings;
    notification_settings?: NotificationSettings;
    privacy_settings?: PrivacySettings;
    friend_id?: number;
    onboarding_step?: number;
    onboarding_complete?: boolean;
    learning_goal?: string;
    learning_duration?: string;
}

export const userSettingService = {
    // Get User Settings
    getUserSettings: async () => {
        const response = await apiClient.get('/api/v1/settings');
        return response.data;
    },

    // Update User Settings
    updateSettings: async (settingsData: UpdateSettingsRequest) => {
        const response = await apiClient.put('/api/v1/settings', settingsData);
        return response.data;
    },
};